import * as React from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

// Drop-in replacement for native <select> using Shadcn/Radix Select.
// Keeps the same API: value / onChange(e => e.target.value) / <option> children.
// This avoids the Emergent visual-editor wrapping <option> nodes and breaking
// React's value inference on native selects.
const EMPTY = "__lselect_empty__"; // Radix disallows "" item values.

export function LSelect({ value, onChange, children, className, placeholder, disabled, "data-testid": testId }) {
  const items = [];
  React.Children.forEach(children, (child) => {
    if (!child || !child.props) return;
    const raw = child.props.value !== undefined ? child.props.value : child.props.children;
    const label = child.props.children !== undefined ? child.props.children : raw;
    items.push({ raw: raw == null ? "" : String(raw), label });
  });

  const toRadix = (v) => (v === "" || v == null ? EMPTY : String(v));
  const fromRadix = (v) => (v === EMPTY ? "" : v);

  return (
    <Select
      value={toRadix(value)}
      onValueChange={(v) => onChange && onChange({ target: { value: fromRadix(v) } })}
      disabled={disabled}
    >
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {items.map((it, i) => (
          <SelectItem key={i} value={toRadix(it.raw)}>
            {it.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
